import * as React from "react";
const SvgFiRrSpider = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-spider_svg__a)">
      <path
        fill="#062147"
        d="m18.793 12.225 3.8 1.689a1.002 1.002 0 0 0 1.32-.508 1 1 0 0 0-.508-1.32l-7.25-3.222 2.958-1.381a5.02 5.02 0 0 0 2.886-4.531V.999a1 1 0 1 0-2 0v1.953a3.01 3.01 0 0 1-1.731 2.718l-2.801 1.307q.032-.234.033-.478c0-1.93-1.57-3.5-3.5-3.5a3.504 3.504 0 0 0-3.467 3.978L5.732 5.67A3.01 3.01 0 0 1 4 2.952V.999a1 1 0 0 0-2 0v1.953a5.02 5.02 0 0 0 2.886 4.531l2.958 1.381-7.251 3.222a1 1 0 1 0 .813 1.828l3.8-1.689L1.4 17.3A7.04 7.04 0 0 0 0 21.5V23a1 1 0 1 0 2 0v-1.5c0-1.075.355-2.141 1-3l2.043-2.724C5.43 19.272 8.403 22 12 22s6.569-2.728 6.957-6.224L21 18.501c.645.858 1 1.924 1 2.999V23a1 1 0 1 0 2 0v-1.5a7.03 7.03 0 0 0-1.4-4.199l-3.806-5.076zM12 5c.827 0 1.5.673 1.5 1.5S12.827 8 12 8s-1.5-.673-1.5-1.5S11.173 5 12 5m0 15c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-spider_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSpider;
